function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "m227.9 58.3c10 0 18.2 8.1 18.2 18.1v0.1 133.2c0 10-8.1 18.2-18.1 18.2h-0.1-205.8c-4.9 0.1-9.5-1.8-12.9-5.3-3.5-3.4-5.4-8-5.3-12.9v-133.1c-0.1-4.9 1.8-9.6 5.3-12.9 3.4-3.5 8-5.4 12.9-5.3h54.4v-18.2c0-10 8.1-18.2 18.1-18.2h0.1 60.6c10 0 18.2 8.1 18.2 18.1v0.1 18.1h54.4zm-205.8 12.2c-1.6 0-3.2 0.6-4.4 1.8-1.2 1.1-1.8 2.7-1.8 4.3v90.9h24.2v-6c0-3.3 2.7-6 6-6h24.3c3.3 0 6 2.7 6 6v6h97v-6c0-3.3 2.7-6 6-6h24.4c3.3 0 6 2.7 6 6v6h24.2v-90.9c0-1.6-0.6-3.1-1.8-4.3s-2.7-1.8-4.4-1.8h-205.7zm205.8 145.4c3.3 0.1 6.1-2.5 6.1-5.8v-0.3-30.3h-24.2v6.1c0 3.3-2.7 6-6 6h-24.3c-3.3 0-6-2.7-6-6v-6.1h-97v6.1c0 3.3-2.7 6-6 6h-24.3c-3.3 0-6-2.7-6-6v-6.1h-24.3v30.3c-0.1 3.3 2.5 6.1 5.8 6.1h0.3 205.9zm-163.5-48.5h-12.1v12.1h12.1v-12.1zm24.3-127.2v18.1h72.7v-18.1c0-3.3-2.7-6-6-6h-60.7c-3.3 0.1-6 2.7-6 6zm109 127.2h-12.1v12.1h12.1v-12.1z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 250 250",
    version: 1.1,
    viewBox: "0 0 250 250",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-cases.6951d566.svg";
export { SvgComponent as ReactComponent };